module.exports = __webpack_public_path__ + "img/video-smoke-logo.7f5b070d.svg";